"use client";

import { captureEvent } from "@/app/_analytics/analytics";
import { EventName } from "@mw/shared/analyticsEventNames";
import { Button } from "@components/core/Button";
import { AISpeechClassifierContext } from "@components/demos/AISpeechClassifier/AISpeechClassifier";
import { useTranslations } from "next-intl";
import { useContext } from "react";

const details = [
  {
    title: "Very unlikely",
    description: "It's very unlikely this audio was generated with ElevenLabs, or the audio was manipulated.",
    threshold: 0.1,
  },
  {
    title: "Unlikely",
    description: "It's unlikely this audio was generated with ElevenLabs, or the audio was manipulated.",
    threshold: 0.33,
  },
  {
    title: "Uncertain",
    description: "We are therefore uncertain whether this audio was generated with ElevenLabs.",
    threshold: 0.66,
  },
  {
    title: "Likely",
    description: "It's likely that this audio was generated with ElevenLabs.",
    threshold: 0.9,
  },
  {
    title: "Very likely",
    description: "It's very likely that this audio was generated with ElevenLabs.",
    threshold: 1.0,
  },
];

export default function Result() {
  const { setView, probability, setProbability } = useContext(AISpeechClassifierContext);
  const t = useTranslations("ClientKeys.AISafetyClassifier");

  return (
    <>
      <div className='flex flex-1 gap-64 pt-72'>
        {probability ? (
          <div className='flex flex-1 flex-col items-center justify-center rounded-lg'>
            <div className='f-ui-01 mb-8'>{details.find(detail => probability < detail.threshold)?.title}</div>
            <p className='f-description-04 max-w-[300px] text-center'>
              {t("probability_result", {
                probability: Math.round(probability * 100),
                description: details.find(detail => probability < detail.threshold)?.description ?? "",
              })}
            </p>
          </div>
        ) : (
          <div className='flex flex-1 items-center justify-center'>{t("no_probability_found")}</div>
        )}
      </div>
      <div className='flex justify-between gap-8 p-16 md:ms-auto'>
        <Button
          onClickCapture={() => {
            captureEvent(EventName.mw_ai_speech_classifier_reset, { version: "v1" });
            setProbability(null);
            setView("overview");
          }}
        >
          {t("upload_another_sample")}
        </Button>
      </div>
    </>
  );
}
